import { MyProjectsApi, Project } from 'cmp-client-api';

import { MyProjectsServiceInterface } from '@src/server/services/types/my-projects-service.interface';
import { MapperInterface } from '@src/server/converters/types/mapper.interface';
import { MyProject } from '@src/domain/pages/my-projects/table/types';

export class MyProjectsService implements MyProjectsServiceInterface {
  private readonly service: MyProjectsApi;

  private readonly mapper: MapperInterface<MyProject[], Project[]>;

  public constructor(service: MyProjectsApi, mapper: MapperInterface<MyProject[], Project[]>) {
    this.service = service;
    this.mapper = mapper;
  }

  public async getMyProjects(): Promise<MyProject[]> {
    return this.service
      .getMyProjects()
      .then(({ data }) => data)
      .then(({ data }) => this.mapper.transformFromApiModel(data));
  }
}
